
// ROUTES
require('modules/material/routes/material');

// CONTROLLERS
require('modules/material/controllers/material');
require('modules/material/controllers/list');
require('modules/material/controllers/edit');

// SERVICES
require('modules/material/services/material');
require('modules/material/services/list');
require('modules/material/services/edit');
require('modules/material/services/delete');


angular.module('unica_material', [

	'infinite-scroll',
	'angular-confirm',
	'bootstrapLightbox',

	// ROUTES
	'unica_material.material_routes',

	// CONTROLLERS
	'unica_material.material_controllers',

	// SERVICES
	'unica_material.material_services'

]);